module.exports = __webpack_public_path__ + "img/Side mirror.6cc848f8.jpg";